function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.2,2.8c-2.5,0-4.8,0.7-6.8,1.8c0.7,0,1.3,0.4,1.6,0.7c0.4,0.4,0.5,0.9,0.7,1.4c1.4-0.7,2.9-1.1,4.5-1.1 c5.7,0,10.6,4.7,10.6,10.6c0,5.7-4.7,10.6-10.6,10.6c-5.7,0-10.6-4.7-10.6-10.6c0.1,0,0.1,0,0.2,0c0-3.2,1.5-4.5,1.5-4.5l1.5,1.2 c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.2,0.4-0.4c0.5-2.5,0.3-5.7,0.3-5.9c0-0.2-0.2-0.4-0.2-0.4C9.6,6.3,9.5,6.3,9.4,6.3 c-0.2,0-3.2-0.2-6,0.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0,0.5,0.2,0.5L4.7,9c0,0-0.5,0.7-0.9,2.1c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.2-0.1,0.4-0.2,0.6c-0.5,1.3-0.7,2.7-0.7,4.2c0,7.3,6.1,13.4,13.4,13.4s13.4-6.1,13.4-13.4S23.5,2.8,16.2,2.8z M38.5,6.3 c-1.1,0-1.8,0.7-1.8,1.8v5.4c0,1.1,0.7,1.8,1.8,1.8c1.1,0,1.8-0.7,1.8-1.8V8.1C40.3,7,39.6,6.3,38.5,6.3z M21.2,9.9 c-0.2,0-0.3,0.1-0.4,0.2l-4.5,4.2c-0.7-0.1-1.3,0-1.8,0.4c-0.7,0.7-0.7,2,0,2.9c0.1,0.1,0.2,0.2,0.3,0.2l0.4,4.4 c0,0.4,0.2,0.7,0.9,0.7c0.5,0,0.9-0.5,0.9-0.7l0.3-4.6c0,0,0,0,0.1-0.1c0.5-0.6,0.6-1.3,0.5-1.9l4-4.6c0.2-0.2,0.4-0.7,0-1.1 C21.6,9.9,21.4,9.9,21.2,9.9z M29.9,9.9c0.9,2,1.5,4.1,1.5,6.3c0,1.6-0.2,3-0.7,4.5h15v23.2c0,1.1-0.7,1.8-1.8,1.8H11.7 c-1.1,0-1.8-0.7-1.8-1.8v-14c-1.2-0.5-2.5-1.4-3.6-2.3v16.1c0,3,2.3,5.4,5.4,5.4h32.2c3,0,5.4-2.3,5.4-5.4V15.3 c0-3-2.3-5.4-5.4-5.4h-1.8v3.6c0,2-1.6,3.6-3.6,3.6c-2,0-3.6-1.6-3.6-3.6V9.9H29.9z M29.6,24.2v3.6h3.6v-3.6H29.6z M36.7,24.2v3.6 h3.6v-3.6H36.7z M15.3,31.4v3.6h3.6v-3.6H15.3z M22.4,31.4v3.6H26v-3.6H22.4z M29.6,31.4v3.6h3.6v-3.6H29.6z M36.7,31.4v3.6h3.6 v-3.6H36.7z M15.3,38.5v3.6h3.6v-3.6H15.3z M22.4,38.5v3.6H26v-3.6H22.4z M29.6,38.5v3.6h3.6v-3.6H29.6z M36.7,38.5v3.6h3.6v-3.6 H36.7z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3",
  className: "st0"
}, /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.5,6.3c-1.1,0-1.8,0.7-1.8,1.8v5.4c0,1.1,0.7,1.8,1.8,1.8c1.1,0,1.8-0.7,1.8-1.8V8.1C40.3,7,39.6,6.3,38.5,6.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3,8.1v5.4c0,1.1,0.7,1.8,1.8,1.8s1.8-0.7,1.8-1.8V8.1c0-1.1-0.7-1.8-1.8-1.8S15.3,7,15.3,8.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.9,9.9h-1.8v3.6c0,2-1.6,3.6-3.6,3.6c-2,0-3.6-1.6-3.6-3.6V9.9h-5h-4.2h-5v3.6c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6 V9.9h-1.8c-3,0-5.4,2.3-5.4,5.4v7.4v4.9v16.1c0,3,2.3,5.4,5.4,5.4h32.2c3,0,5.4-2.3,5.4-5.4V15.3C49.2,12.2,46.9,9.9,43.9,9.9z  M45.7,43.9c0,1.1-0.7,1.8-1.8,1.8H11.7c-1.1,0-1.8-0.7-1.8-1.8v-14v-7v-2.2h15h5.7h15V43.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "36.7,25.2 25,36.8 18.9,30.7 16.3,33.3 25,42.1 39.3,27.8  "
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.8,4.7v42.6h46.5V4.7H2.8z M6.6,8.6h38.7v3.9H6.6V8.6z M6.6,16.3h38.7v27.1H6.6V16.3z M12.4,20.2v3.9h27.1v-3.9H12.4z  M12.4,27.9v3.9h3.9v-3.9H12.4z M20.2,27.9v3.9h19.4v-3.9H20.2z M12.4,35.7v3.9h3.9v-3.9H12.4z M20.2,35.7v3.9h19.4v-3.9H20.2z"
}));

function SvgIconOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverview);
export default __webpack_public_path__ + "static/media/icon_overview.2decbdf6.svg";
export { ForwardRef as ReactComponent };